import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeFromNow',
  standalone: true,
  pure: true,
})
export class TimeFromNowPipe implements PipeTransform {
  transform(value: Date | string | number | null | undefined): string {
    if (value == null) return '';

    const date = this.toDate(value);
    if (!date) return '';

    return diffFromNow(date);
  }

  private toDate(value: Date | string | number): Date | null {
    if (value instanceof Date) {
      return isNaN(value.getTime()) ? null : value;
    }

    const d = new Date(value);
    return isNaN(d.getTime()) ? null : d;
  }
}

function diffFromNow(date: Date): string {
  const now = new Date();

  const isFuture = date.getTime() > now.getTime();
  const start = isFuture ? now : date;
  const end = isFuture ? date : now;

  const diffMs = end.getTime() - start.getTime();
  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffMinutes < 60) return format(diffMinutes, 'minuto', isFuture);
  if (diffHours < 24) return format(diffHours, 'hora', isFuture);
  if (diffDays < 30) return format(diffDays, 'dia', isFuture);

  const months =
    (end.getFullYear() - start.getFullYear()) * 12 +
    (end.getMonth() - start.getMonth());

  if (months < 12) return format(months, 'mes', isFuture);

  const years = Math.floor(months / 12);
  return format(years, 'ano', isFuture);
}

function format(value: number, unit: string, isFuture: boolean): string {
  let plural = value === 1 ? unit : `${unit}s`;
  if (value > 1 && unit == 'mes') plural = 'meses';
  return isFuture ? `in ${value} ${plural}` : `${value} ${plural}`;
}
